import React from 'react';
import { Accordion, HeadingLevel } from '@trussworks/react-uswds';
import { MarkdownRenderer } from '@components/markdown-renderer/MarkdownRenderer';
import classnames from 'classnames';
import './jpaOrgSummary.scss';

type JpaOrgData = { jpaOrgID: number; orgName: string; introText: string };

const renderJpaOrg = (jpaData: JpaOrgData[]) =>
  jpaData.map((jpa, index) => ({
    content: <MarkdownRenderer text={jpa.introText} />,
    expanded: true,
    headingLevel: 'h6' as HeadingLevel,
    id: index.toString(),
    title: jpa.orgName,
  }));

type JpaOrgProps = {
  hasJpa: boolean;
  orgData?: JpaOrgData[];
  renderAccordionItems: (orgData: JpaOrgData[]) => [];
  titleText?: string;
  isExpanded?: boolean;
  className?: string;
};

const JpaOrgSummary: React.FC<JpaOrgProps> = ({
  hasJpa,
  orgData,
  renderAccordionItems = renderJpaOrg,
  titleText = 'Based on the Project Location, additional regulatory requirements may be necessary.  This information will be automatically displayed (when appropriate) based on your responses to questions in the form.',
  isExpanded = true,
  className = '',
}) => {
  if (!hasJpa) return null;
  const data = orgData ?? [];
  const isMultiOrg = data.length > 1;
  const firstOrg = data[0];
  const containerStyles = classnames('jpa-org', className);

  return (
    <div className={containerStyles}>
      <Accordion
        className='jpa-content margin-bottom-1'
        bordered
        items={[
          {
            id: 'joint-permit',
            headingLevel: 'h6',
            title: titleText,
            content: (
              <div>
                {isMultiOrg ? (
                  <Accordion className='jpa-items' bordered items={renderAccordionItems(data)} multiselectable />
                ) : (
                  <div>
                    {!!firstOrg?.orgName && <h6 className='margin-top-0'>{firstOrg.orgName}:</h6>}
                    {!!firstOrg?.introText && <MarkdownRenderer text={firstOrg.introText} />}
                  </div>
                )}
              </div>
            ),
            expanded: isExpanded,
          },
        ]}
      />
    </div>
  );
};
export default JpaOrgSummary;
